import { IGroupedApiCtx } from '../../api/apiCommon';
import { CancelError, ISportsBettingBaseApi, ITicketValidateParams } from '../../api/apiBase';
import { ITicketResponse } from '../../api/proto/apiContract';
/**
 * Special wrapper to handle cancel of modifyOdds requests since api cannot handle more concurrent requests to coupon for the same token (intended protection).
 */
export class ModifyOddsCtxWrapper {

    private ctx: IGroupedApiCtx<ISportsBettingBaseApi>;
    private promiseSolutions: { resolve: (() => void), reject: (_reason: any) => void }[];
    private isVirtuallyCancelled: boolean = false;

    constructor(ctx: IGroupedApiCtx<ISportsBettingBaseApi>) {
        this.ctx = ctx;
    }

    public async validateTicketCancelableAsync(params: ITicketValidateParams): Promise<ITicketResponse> {
        // TODO experimental code with async, but generally not compatible with mobx handling. Better to change, left as working.
        let response: ITicketResponse = await this.ctx.api.ticketValidateAsync(params);
        if (this.isVirtuallyCancelled) {
            throw new CancelError();
        }
        return response;
    };

    public cancel(_message: string): Promise<void> {
        /*if (this.ctx.isOpen()) {    ! do not cancel api request since it doesn't wait to finish the request
            this.ctx.cancel(message);
        }*/
        this.isVirtuallyCancelled = true;
        if (this.promiseSolutions == null) {
            this.promiseSolutions = [];
        }
        return new Promise((resolve, reject) => {
            this.promiseSolutions.push({ resolve: resolve, reject: reject });
        });
    }

    public close() {
        this.ctx.close();
        if (this.promiseSolutions != null) {
            this.promiseSolutions.forEach((value) => {
                value.resolve();
            })
        }
    }
}